function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { useCallback } from "react";
import { ItemType, FollowStatus, useTopicPage_SetTopicFollowMutation } from "sprout-graphql";
import { useSnackbar } from "sprout-ui-dom/dist/Snackbar";
function useSetTopicFollow({ topicId , withNotifications , nodeId  }) {
    const showSnackbar = useSnackbar();
    const [setTopicFollow] = useTopicPage_SetTopicFollowMutation({
        variables: {
            topicId,
            withNotifications
        },
        optimisticResponse: {
            setTopicFollow: {
                query: {
                    nodeId: "query",
                    itemById: {
                        nodeId,
                        id: topicId,
                        type: ItemType.Topic,
                        currentUserFollowStatus: withNotifications ? FollowStatus.Subscribed : FollowStatus.Following,
                        __typename: "Item"
                    },
                    __typename: "Query"
                },
                __typename: "SetTopicFollowPayload"
            }
        }
    });
    return useCallback(_asyncToGenerator(function*() {
        try {
            yield setTopicFollow();
            showSnackbar({
                message: `Notifications turned ${withNotifications ? "on" : "off"}`
            });
        } catch (e) {
            showSnackbar.error();
        }
    }), [
        showSnackbar,
        setTopicFollow,
        withNotifications
    ]);
}
export default useSetTopicFollow;
